import { Tooltip, UIText1 } from '@cian/ui-kit';
import { IconFunctionalHelpCircle16 } from '@cian/ui-kit-design-tokens/icons';
import styles from './Subtitle.css';
import { FC, ReactNode } from 'react';
import { NBSP } from 'shared/constants/symbols';

interface ISubtitleProps {
  onTooltipOpen?: VoidFunction;
  tooltipContent: ReactNode;
}

export const Subtitle: FC<ISubtitleProps> = ({ onTooltipOpen, tooltipContent }) => {
  return (
    <div className={styles['tooltip-box']}>
      <Tooltip
        onOpen={onTooltipOpen}
        theme="white"
        placement="bottom-end"
        header="Какие дома мы считаем соседними"
        title={tooltipContent}
      >
        <UIText1>
          Делаем выводы на{NBSP}основе объектов в{NBSP}этом и{NBSP}соседних домах{' '}
          <div data-testid="marketTrendsOnTitleTooltipOpenId" className={styles['tooltip-icon']}>
            <IconFunctionalHelpCircle16 color="icon-secondary-default" />
          </div>
        </UIText1>
      </Tooltip>
    </div>
  );
};
